import { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { useGridLayers } from '../../hooks/useGridLayers';
import styles from './FilterBar.module.css';

const FILTERS = [
  { id: 'all',     label: 'ALL' },
  { id: 'missing', label: 'MISSING' },
  { id: 'found',   label: 'FOUND' },
];

const LAYER_OPTIONS = [
  { id: 'sharedPlaces', label: 'Shared places',  mark: '×2' },
  { id: 'hunted',       label: 'Hunt',           mark: 'HUNT' },
  { id: 'duplicates',   label: 'Duplicate count', mark: '#' },
];

export function FilterBar({ layers, toggleLayer }) {
  const { state, dispatch } = useAppContext();
  const [layersOpen, setLayersOpen] = useState(false);
  const popRef = useRef(null);

  const activeCount = LAYER_OPTIONS.filter(l => layers[l.id]).length;

  useEffect(() => {
    if (!layersOpen) return;
    function handlePointerDown(e) {
      if (popRef.current && !popRef.current.contains(e.target)) setLayersOpen(false);
    }
    function handleKeyDown(e) {
      if (e.key === 'Escape') setLayersOpen(false);
    }
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [layersOpen]);

  return (
    <div className={styles.bar}>
      <div className={styles.chips}>
        {FILTERS.map(f => (
          <button
            key={f.id}
            className={`${styles.chip} ${state.activeFilter === f.id ? styles.active : ''}`}
            onClick={() => dispatch({ type: 'SET_FILTER', filter: f.id })}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className={styles.layersWrap} ref={popRef}>
        <button
          className={styles.layersTrigger}
          onClick={() => setLayersOpen(o => !o)}
          aria-haspopup="true"
          aria-expanded={layersOpen}
        >
          LAYERS {activeCount} <span className={styles.caret}>▾</span>
        </button>

        {layersOpen && (
          <div className={styles.layersMenu} role="menu">
            {LAYER_OPTIONS.map(l => (
              <label key={l.id} className={styles.layerRow}>
                <input
                  type="checkbox"
                  checked={!!layers[l.id]}
                  onChange={() => toggleLayer(l.id)}
                />
                <span className={styles.layerLabel}>{l.label}</span>
                <span className={styles.layerMark}>{l.mark}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FilterBar;
